module.exports = __webpack_public_path__ + "/login_ui/img/tk-e770bcfe98266aac1acdb64e3f1fc336.svg";